import { ReactNode } from "react";

interface BtnProps {
  children: ReactNode;
  onClick?: () => void;
  active?: boolean;
  /** 送出/查詢進行中：禁點 + 顯示轉圈與 busyText，避免看起來像當機。 */
  busy?: boolean;
  /** busy 時顯示的文字（預設「處理中…」；查詢類動作可傳更明確的說明）。 */
  busyText?: string;
}

export const PrimaryBtn = ({ children, onClick, active = true, busy = false, busyText = "處理中…" }: BtnProps) => {
  const clickable = active && !busy;
  return (
    <button
      onClick={clickable ? onClick : undefined}
      disabled={busy}
      className={`w-full py-4 rounded-[30px] border-none text-base font-bold transition-colors flex items-center justify-center gap-2 ${
        clickable ? "bg-[#2196f3] text-white cursor-pointer" : "bg-[#E5E7EB] text-[#999] cursor-default"
      }`}
    >
      {busy && (
        <span className="inline-block w-[18px] h-[18px] border-2 border-current border-t-transparent rounded-full animate-spin" />
      )}
      {busy ? busyText : children}
    </button>
  );
};

export const GhostBtn = ({ children, onClick }: BtnProps) => (
  <button
    onClick={onClick}
    className="w-full py-[15px] rounded-[30px] border-[1.5px] border-[#E5E7EB] bg-white text-[#475569] text-[15px] font-semibold cursor-pointer"
  >
    {children}
  </button>
);
